import { render, staticRenderFns } from "./FPegawaiDialog.vue?vue&type=template&id=700ff487&scoped=true"
import script from "./FPegawaiDialog.vue?vue&type=script&lang=js"
export * from "./FPegawaiDialog.vue?vue&type=script&lang=js"
import style0 from "./FPegawaiDialog.vue?vue&type=style&index=0&id=700ff487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ff487",
  null
  
)

export default component.exports